<template>
  <div>
    <template v-if="!complete">
    <div class="sm:mx-auto sm:w-full sm:max-w-screen-md">
      <h2 class="mt-6 text-center text-2xl font-extrabold text-brand-gray-900">
        Complete Your Registration
      </h2>
      <div v-if="errors.length > 0" class="mt-4 bg-amber-50 border-l-4 border-amber-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <!-- Heroicon name: solid/exclamation -->
            <svg class="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-amber-700">
              {{error}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 sm:mx-auto sm:w-full sm:max-w-screen-sm">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <p class="mt-2 text-center text-sm text-brand-gray-600">The registration code you entered enrolls you into the following product(s). If everything looks as you expect,
        please click the button below to complete your registration.</p>
        <ul class="mt-4 space-y-4 divide-y divide-brand-gray-200">
          <li v-for="item in items" class="text-center text-sm font-medium">{{item.name}}</li>
        </ul>
        <form method="post" @submit.prevent="submit" class="mt-4 flex justify-center">
          <button type="submit"
                  :disabled="submitting"
                  class="w-full sm:w-1/2 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:bg-purple-300 disabled:cursor-wait">
                          <span class="flex" v-if="submitting">
                              <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none"
                                   viewBox="0 0 24 24">
                              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                              <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg> Finalizing
                          </span>
            <span v-else>Complete Registration</span>
          </button>
        </form>
      </div>
    </div>
    </template>
    <template v-else>
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 class="mt-6 text-center text-2xl font-medium text-brand-gray-900">
          Registration Completed
        </h2>
        <p class="mt-2 text-center text-sm text-brand-gray-600">
          Your registration has been completed. You can now visit your
          <a href="/my-account" class="font-medium text-indigo-600 hover:text-indigo-900">My Account</a> page to view course content.
        </p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CompleteRegistration',

  props: {
    code: {type: Object, required: true},
    user: {type: Object, required: true},
    shippingAddress: {type: Object, required: false, default: null}
  },

  data() {
    return {
      complete: false,
      errors: [],
      items: [],
      submitting: false
    }
  },

  async created() {
    const { data } = await axios.get(`/api/org-code-preview/${this.code.org_code}`);
    this.items = data;
  },

  methods: {
    async submit() {
      this.submitting = true;
      const { data } = await axios.post(`/api/bookstore/complete-registration`, {
        registrationCode: this.code.registration_code,
        shippingAddress: this.shippingAddress
      });

      this.complete = true;
      this.submitting = false;
    }
  }
};
</script>

<style scoped>

</style>